export default "__VITE_ASSET__Dg3mnHbR__"